class CustomDialog extends HTMLElement {
    constructor() {

        super();
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
    }

    connectedCallback() {

        this.dialog = this.querySelector('dialog');
        const dataTargetValue = this.getAttribute('data-target');
        this.buttons = document.querySelectorAll(`button[data-target="${dataTargetValue}"]`);
        this.closeButton = this.querySelectorAll(`button[data-dialog="close"]`);

        if (!this.dialog) {
            console.error(`'${dataTargetValue}: Button or Dialog not found in DOM.'`);
            return
        }

        this.buttons.forEach(button => {
            button.addEventListener('click', this.handleButtonClick);
        });

        this.closeButton.forEach(button => {
            button.addEventListener('click',() => {
                if (this.dialog.querySelector('.dialog')) {
                    this.dialog.querySelector('.dialog')?.classList.add('fade-in');
                } else {
                    this.dialog.classList.remove('fade-in');
                }
                this.dialog.close();
            });
        });

        this.dialog.addEventListener('click', this.handleDialogClose);

    }

    disconnectedCallback() {
        if (this.button) {
            this.button.removeEventListener('click', this.handleButtonClick);
        }
        if (this.dialog) {
            this.dialog.removeEventListener('close', this.handleDialogClose);
        }
    }

    handleButtonClick() {
        if (!this.dialog) return

        const dialogToFadeIn = this.dialog.querySelector('.dialog') || this.dialog
        dialogToFadeIn.classList.add('fade-in');
        this.dialog.showModal();

    }

    handleDialogClose(event) {
        publish(PUB_SUB_EVENTS.popupClose)
        if (!this.dialog) return
        const rect = this.dialog.getBoundingClientRect();
        const isInDialog =
            event.clientX >= rect.left &&
            event.clientX <= rect.right &&
            event.clientY >= rect.top &&
            event.clientY <= rect.bottom;

        if (isInDialog) return
        setTimeout(() =>{
            this.dialog.close();
        }, 400);

        if (this.dialog.querySelector('.dialog')) {
            this.dialog.querySelector('.dialog')?.classList.add('fade-in');
        } else {
            this.dialog.classList.remove('fade-in');
        }
    }

}
customElements.define('custom-dialog', CustomDialog);
